<section class="petPrescription" id="homeHero">
  <div class="prescriptionRow bestPriceRow">
    <div class="petRxHacker">
      <h2 class="get-up">Discounts on Pet Medication!</h2>
      <p class="use">Use your NuLifeSpan Rx card to save on medication for your furry friends</p>
      <div class="nav-adjust home">        
        <app-search></app-search>        
      </div>
    </div>
    <img src="../../assets/images/petHero.png">
  </div>
  <!-- <img src="../../assets/images/dotHero.png" class="dottedHero"> -->
  <img src="../../assets/images/seperator.svg" class="hero-seperator" />
</section>
<!--
<div class="skeltonloade" *ngIf="!carouselloaded">
  <div class="logobox">
    <div class="box"></div>
    <div class="box"></div>
    <div class="box"></div>
    <div class="box"></div>
    <div class="box"></div>
  </div>
  <div class="slideboxparent">
    <div class="box"></div>
    <div class="box"></div>
    <div class="box"></div>
  </div>
</div>-->
<section class="petPrescriptionWorks">
  <div class="PrescriptionHowWorks">
    <h2>How it works</h2>
    <p>Use your card for your pet as you would for yourself</p>
  </div>
  <div class="PrescriptionHowWorksRight">
  <div class="PrescriptionWorksTxt">
    <img src="../../assets/images/medication.svg">
    <div class="pres-heading">
      <h3>Get Prescription</h3>
      <p>Make sure to get a prescription from your vet</p>  
    </div>
  </div>
  <div class="PrescriptionWorksTxt">
    <img src="../../assets/images/discounted.svg">
    <div class="pres-heading">
      <h3>Compare Prices</h3>
      <p>Use our pricing tool to find the cheapest pharmacy for your the pet medication you need</p>
    </div>
  </div>
  <div class="PrescriptionWorksTxt">
    <img src="../../assets/images/pharmacy.svg">
    <div class="pres-heading">
      <h3>Show Pharmacists, Always!</h3>
      <p>As always, show your card to your pharmacist and enjoy instant savings!</p>
      </div>
  </div>
  </div>
  </section>
  <section class="discountCard">
    <div class="discountCardRow">
      <div class="discountCardRowLeft">
        <h2>Get your free NuLifeSpan Rx discount card today</h2>
        <p>It’s easy to start saving on your prescription drugs. Simply download our discount card today and start enjoying big savings on your medications.</p>
        <div class="walletDiv">
          <div class="discountWallet"  (click)="openpass(applegenericpassval)"  *ngIf="ios">
            <img src="../../assets/images/apple_wallet.png">
            <span>Add to Apple wallet</span>
          </div>
          <div class="discountWallet google-wall" (click)="openpass(googlegenericpassval)" *ngIf="android">
          <img src="../../assets/images/google_wallet.png">
          <span>Add to Google wallet</span>
        </div>
        </div>
        <button class="" (click)="newDiscountModal()">Download Your Free Card Now</button>
      </div>
      <div class="discountCardRowRow">
        <img src="../../assets/images/getCard.png" class="forDesktop">
        <img src="../../assets/images/getCardMob.png" class="forMobile">
      </div>
    </div>
  </section>
  <section class="petPrescriptionBenefits">
    <div class="petPrescriptionBenefitsLeft">
      <h2>Benefits of using the NuLifeSpan Rx card for Pet prescriptions</h2>
      <p>There are several reasons why you should consider using the NuLifeSpan Rx card for your pet’s prescriptions:</p>
      <button class="mobileHidden" (click)="newDiscountModal()">Download your NuLifeSpan Rx card now</button>
    </div>
  <div class="petPrescriptionBenefitsRight">
    <div class="petPrescriptionBenefitsIcons">
      <img src="../../assets/images/saveMoney.svg">
      <div>
        <h5>Save Money</h5>
        <p>Pet medications can be expensive, but with the NuLifeSpan Rx card, you can get the same medications for less.</p>
      </div>
    </div>
    <div class="petPrescriptionBenefitsIcons">
      <img src="../../assets/images/wide_network.svg">
      <div>
        <h5>Wide network</h5>
        <p>Our card is accepted at over 65,000 pharmacies nationwide, making it easy to find a participating location near you.</p>
      </div>
    </div>
    <div class="petPrescriptionBenefitsIcons">
      <img src="../../assets/images/no_restriction.svg">
      <div>
        <h5>No restrictions</h5>
        <p>There are no age, income, or pre-existing condition restrictions to use the NuLifeSpan Rx card for your pet’s prescriptions.</p>
      </div>
    </div>
    <div class="petPrescriptionBenefitsIcons">
      <img src="../../assets/images/easy_to_use.svg">
      <div>
        <h5>Easy to use</h5>
        <p>Just show your NuLifeSpan Rx card at the pharmacy to get the discounted price – no need to fill out forms or wait for approval.</p>
      </div>
    </div>
    <button class="petMobBtn desktopHidden" (click)="newDiscountModal()">Download your NuLifeSpan Rx card now</button>
  </div>
  </section>
  <!--
  <section class="bestPrice adjust" id="navSearchBar">
    <div class="bestPriceRow">
      <div class="bestPriceLeft">
        <h2>Find the best prices on your pet prescriptions</h2>
        <p>Our pricing tool makes it easy to find the lowest prices on your medications. Simply enter the name of your drug, and we’ll show you the prices at pharmacies near you.</p>
        <nav-search></nav-search>
        <button>Find the Lowest Price</button>
      </div>
      <img src="../../assets/images/bestPrice.png">
    </div>
  </section>  
-->
  <!-- // carosuel section \\ -->
<section class="hero-shape-left reviewSection">
  <div class="work-section margin-221">
    <div class="columns is-vcentered">
      <div class="column reviewsRow ">
        <!-- Best price  -->
        <h2 class="customer-review-title">See what our customers are saying</h2>
        <p>Don’t just take our word for it. See what some of our satisfied customers have to say about our discount card:</p>
        <button class="mobileHidden" (click)="newDiscountModal()">Get Your Free Card Now</button>
      </div>
      <div class="column quotes-img petQuotesImg">
        <div class="customer-review-box petReviews">
          <div class="review">

            <ngx-slick-carousel class="review" #slickModal="slick-carousel" [config]="slideConfig">
              <div ngxSlickItem *ngFor="let slide of slides" class="slide" style="width: 290px !important;">
                <h5 class="customer-review">{{ slide.text }}</h5>
                <p class="review-src">{{ slide.heading }}</p>
                <span class="review-src">{{ slide.source }}</span>
                <!-- <div class="stars">
                  <span class="star-rating-text">5/5</span>
                  <img src="/assets/images/star.svg" class="star">
                  <img src="/assets/images/star.svg" class="star">
                  <img src="/assets/images/star.svg" class="star">
                  <img src="/assets/images/star.svg" class="star">
                  <img src="/assets/images/star.svg" class="star">
                </div> -->
              </div>
            </ngx-slick-carousel>
          </div>
        </div>
      </div>
    </div>
  </div>
  <button class="desktopHidden petReviewMob" (click)="newDiscountModal()">Get Your Free Card Now</button>
</section>
<!-- \\ carosuel section // -->
 <div class="pharmacyPage newDiscountCardModal printView" *ngIf="newDisCardModal" id="printArea">
  <div class="discount_card"  id="print-section">
    <div class="close_search_pharmacy_popup" (click)="CloseNewCardModal()"></div>

    <div class="discount_card_parent">
      <div class="header">
        <img src="../../assets/images/logo-white-bg.png" alt="" />
        <div class="button_sec">
          <div class="print" (click)="PrintMe()" data-after="Print"></div>
          </div>
        </div>
      
      <div class="pharmacyDetail">
       
        <div class="border-bottom"></div>
        
        <div class="discountModalTxt"><h5>For use at any major retail pharmacy and save!</h5></div>
          <div class="method_salt two">
          <div class="method">
            <div>bin</div>
            <div>023518</div>
          </div>
          <div class="method">
            <div>PCN</div>
            <div>ARX</div>
          </div>
          <div class="method">
            <div>Member ID</div>
            <div>100-4542</div>
          </div>
          <div class="method">
            <div>Group</div>
            <div>{{newCardGroupNo}}</div>
          </div>
        </div>
        <p class="no-insurance pt-0">The NuLifeSpan Rx prescription discount program is free. <span class="strong-text">This is not insurance.</span></p>
        <!-- <div class="email_field" style="position: relative">
          <input type="email" id="email" name="ShareEmail" placeholder=" " [(ngModel)]="UserInputEmail"
            (click)="ClearMessage($event)" (blur)="ClearMessage($event)" (keypress)="clearClassMsg()"
            autocomplete="off" />
          <label for="email">Enter your E-mail</label>
          <div class="sendbtn" (click)="ShareDiscountCard()">Send</div>
          <div class="loadProcess"></div>
        </div> -->
        <span style="color:#f19f57">{{ SendDiscountMessage }}</span>
        <!-- <div class="helpline_btn">
          <div class="helpline" (click)="PharmacyHelpLine()">
            {{ PharmacistHelpline }}
          </div>
          <div class="direction" (click)="RedirectGoogleDirection()">
            Get Directions
            <img src="../../assets/images/direction.svg" alt="" />
          </div>
        </div> -->
      </div>
    </div>
  </div>
 </div>
   <!-- // accordian section \\ -->
<section class="accordian-section needHelp contactSecFour home-accordian" id="faqs">
  <div class="comman-width">
    <app-pets-accordian></app-pets-accordian>
  </div>
</section>
<!-- \\ accordian section // -->